import { connect } from 'react-redux';
import { Tooltip } from '@mui/material';
import { WorkspacePremium } from '@mui/icons-material';
import EnumSelector from './EnumSelector';
import { unique } from '../../../utils/collections';

const TYPE = 'Unit Selector';
const Selector = ({
  entities,
  onChange,

  units,
}) => {
  const points = entities;
  const unitPredictions = unique(points.map((p) => p.data?.predicted_unit));
  const unitPrediction = unitPredictions.length === 1 ? unitPredictions[0] : null;
  return (
    <EnumSelector
      entities={points}
      onChange={onChange}
      formId={TYPE}
      name="Unit"
      enums={units}
      extractEnumId={(p) => p.rawUnitId}
      enumId={(u) => u.id}
      enumLabel={(u) => u.name_long}
      renderBadge={(u) =>
        unitPrediction === u.nameAbbr ? (
          <Tooltip title="Onboard recommended unit">
            <WorkspacePremium color="secondary" />
          </Tooltip>
        ) : null
      }
    />
  );
};

const mapStateToProps = (state) => ({
  units: state.entities.units.byId,
});

const UnitSelector = connect(mapStateToProps)(Selector);

UnitSelector.displayName = TYPE;

export default UnitSelector;
